import React from 'react';
// material
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import CreateCampaignButton from "./CreateCampaignButton";
import FullImage from './FullImage'

import HomeButton from './HomeButton';

const styles:any = {
  button: {
    width: 240,
    height: 50,
    borderRadius: 4,
    border: 'none',
    backgroundColor: '#00ABCA',
    fontSize: 20,
    fontFamily: 'Asap',
    textAlign: 'center',
    color: '#FFFFFF',
    cursor: 'pointer'
  },
  flexBox:{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: "100%",
    padding:20
  },
  flexLeftBox:{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: "100%",
  }
}

interface RightBannerProps {
  icon?: string;
  title: string;
  text: string;
  link: string;
  banner: string;
  onClick(action: string, route: string): void;
}

const RightBanner: React.FC<RightBannerProps> = (props) => {

  const classes = useStyles({});
  return (
    <div className={classes.mainContainer}>
      <Grid container className={classes.container}>
        <Grid item xs={12} md={6} sm={12} style={styles.flexLeftBox}>
          <FullImage src={props.banner}/>
        </Grid>
        <Grid item xs={12} md={6} sm={12} style={styles.flexBox}>
          <div className={classes.textContainer}>
          <div className={classes.title}>{props.title}</div>
            <div className={classes.text}>{props.text}</div>
            <div className={classes.buttonContainer}>
              <HomeButton text="Get started" onClick={() => props.onClick('signup', '')} />
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  )
};
export default RightBanner;

const useStyles = makeStyles(theme => ({
  mainContainer:{
    backgroundColor: '#F4F7FC',
    display:"flex",
    justifyContent:"center",
    alignItems: "center"
  },
  container: {
    maxWidth:1100,
    padding: 80,
    [theme.breakpoints.down('md')]: {
      padding: 30
    }
  },
  innerContainer: {
    width: '80%',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  textContainer: {
    padding: "0 0 0 60px",
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    }
  },
  iconContainer: {
  },
  title: {
    textAlign: 'left',
    color: '#577093',
    fontFamily: 'Asap',
    fontSize: '34px',
    letterSpacing: 0,
  },
  text: {
    padding:'20px 0',
    textAlign: 'left',
    color: '#587191',
    fontFamily: 'Asap',
    fontSize: '20px',
    letterSpacing: 0,
    lineHeight: '23px'
  },
  buttonContainer: {
    [theme.breakpoints.down("sm")]: {
      display: 'flex',
      justifyContent: 'center'
    },
  }
}));


// WEBPACK FOOTER //
// ./src/pages/home/components/RightBanner.tsx